import { render, staticRenderFns } from "./PanelComponent.vue?vue&type=template&id=7baebbbc&scoped=true"
import script from "./PanelComponent.vue?vue&type=script&lang=js"
export * from "./PanelComponent.vue?vue&type=script&lang=js"
import style0 from "./PanelComponent.vue?vue&type=style&index=0&id=7baebbbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baebbbc",
  null
  
)

export default component.exports